import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import { set as setCookie } from '@helpers/cookie';
import { getUtmSource } from '../helpers/query';

export const track = () => {
    const params = Object.fromEntries(new URLSearchParams(window.location.search));
    const utmSource = getUtmSource(params);

    if (utmSource && utmSource.toLowerCase() === 'newsletter' && typeof params.mid !== 'undefined') {
        const {
            e,
            j,
            l,
            u,
            jb,
            mid,
            sfmc_sub,
        } = params;

        setCookie('newsletter', JSON.stringify(pickBy({
            e,
            j,
            l,
            u,
            jb,
            mid,
            sfmc_sub,
        }, identity)), { expires: 30, path: '/' });
    }
};
